'use client';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

export type FaqItem = {
  question: string;
  answer: string;
};

export type Props = {
  faqItems: FaqItem[];
};

export default function FAQ({ faqItems }: Props) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [seeMore, setSeeMore] = useState<boolean>(false);

  const handleClick = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(null);
      setSeeMore(false);
    } else {
      setActiveIndex(index);
      setSeeMore(false);
    }
  };

  const handleSeeMore = () => {
    setSeeMore(true);
  };

  return (
    <div className="text-creme">
      <h2 className="mb-4 text-4xl font-semibold title-white">FAQs</h2>
      <div className="flex flex-col gap-4">
        {faqItems.map((item, index) => (
          <div
            key={index}
            className="bg-white bg-opacity-10 p-4 rounded-lg flex flex-col cursor-default"
          >
            <div
              className="flex flex-row justify-between cursor-pointer items-center"
              onClick={() => handleClick(index)}
            >
              <p className="max-w-prose self-center text-2xl">
                {item.question}
              </p>
              <div className="ml-4 rounded-full border-creme border-2 h-fit w-fit">
                <div className="size-8 flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={activeIndex === index ? faMinus : faPlus}
                  />
                </div>
              </div>
            </div>
            <div
              className={
                'pl-4 border-l-2 border-creme border-opacity-75 transition-height antialiased font-light duration-500 ease-in ' +
                (activeIndex === index
                  ? 'h-fit opacity-100 mt-2'
                  : 'h-0 opacity-0 overflow-hidden')
              }
            >
              <p
                className={
                  'max-w-prose leading-relaxed text-justify ' +
                  (seeMore ? 'line-clamp-none' : 'line-clamp-3')
                }
              >
                {item.answer}
              </p>
              {!seeMore && (
                <div
                  className="mt-2 underline font-semibold cursor-pointer"
                  onClick={() => handleSeeMore()}
                >
                  See more
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
